import React, { useState } from 'react';
import Spinner from './Spinner';

const EditableCell = ({
  value,
  isEditing,
  isUpdating = false,
  onEdit,
  onSave,
  onCancel,
  onKeyDown,
  inputType = "text",
  inputProps = {},
  displayFormat = (val) => val,
  className = "",
  editClassName = "w-24 px-2 py-1 border rounded text-sm focus:ring-2 focus:ring-btn-primary focus:border-transparent",
  displayClassName = "cursor-pointer hover:bg-gray-50 px-2 py-1 rounded",
  editTitle = "Click to edit",
  saveTitle = "Save",
  cancelTitle = "Cancel",
  showButtons = true,
}) => {
  const [tempValue, setTempValue] = useState(value?.toString() || '');

  const handleEdit = () => {
    setTempValue(value?.toString() || '');
    onEdit();
  };

  const handleSave = () => {
    onSave(tempValue);
  };

  const handleCancel = () => {
    setTempValue(value?.toString() || '');
    onCancel();
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSave();
    } else if (e.key === 'Escape') {
      handleCancel();
    }
    if (onKeyDown) onKeyDown(e);
  };

  if (isEditing) {
    return (
      <div className={`flex items-center gap-2 ${className}`}>
        <input
          type={inputType}
          value={tempValue}
          onChange={(e) => setTempValue(e.target.value)}
          onKeyDown={handleKeyDown}
          className={editClassName}
          autoFocus
          {...inputProps}
        />
        {showButtons && (
          <div className="flex gap-1">
            <button
              onClick={handleSave}
              disabled={isUpdating}
              className="p-1 text-green-600 hover:bg-green-50 rounded"
              title={saveTitle}
            >
              {isUpdating ? (
                <Spinner text="" size="small" className="text-green-600" />
              ) : (
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              )}
            </button>
            <button
              onClick={handleCancel}
              disabled={isUpdating}
              className="p-1 text-red-600 hover:bg-red-50 rounded"
              title={cancelTitle}
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        )}
      </div>
    );
  }

  return (
    <div
      className={displayClassName}
      onClick={handleEdit}
      title={editTitle}
    >
      {displayFormat(value)}
    </div>
  );
};

export default EditableCell;